// 企業名検索履歴に追加
export const addCompanyHistory = (companyName: string, meta: string) => ({
  type: "strategyScanner/COMPANY_HISTORY_ADD" as const,
  payload: { companyName, meta }
});

// 経営戦略スキャナーストアをクリア
export const clearState = () => ({
  type: "strategyScanner/CLEAR_STATE" as const
});

export type StrategyScannerAction = ReturnType<
  typeof addCompanyHistory | typeof clearState
>;
